import { StatusQueryState } from '../enums';

export const StatusQueryStates = [
  { name: 'Active', value: StatusQueryState.Active },
  { name: 'Disabled', value: StatusQueryState.Disabled },
  { name: 'Deleted', value: StatusQueryState.Deleted },
];
